<script>
  // @ts-check
  import { createEventDispatcher } from "svelte";
  import AccordionItem from "./AccordionItem.svelte";

  /** Primarily used for testing
   * @type {string} */
  export let id = undefined;

  /**
   * @type {import('./AccordionTypes').AccordionItemListType[]} props - The component props.
   */
  export let items = [];

  /** The class to be applied to the each accordion item
   *  @type {string}
   * */
  export let itemContainerClass = "";

  /** The class to be applied to the heading of the accordion item
   *  @type {string}
   * */
  export let itemHeadingClass = "";

  /** The class to be applied to the body of the slot item
   *  @type {string}
   * */
  export let itemBodySlotClass = "";

  const dispatch = createEventDispatcher();
  const onCheckBoxSelectionGroup = (e) => {
    dispatch("checkBoxSelectionGroup", { value: e.detail.value });
  };
</script>

<div {id} class="embedded-content override-item w-full">
  {#each items as item}
    <AccordionItem
      label={item.headline}
      subtitle={item.subtitle}
      active={item.active}
      {itemHeadingClass}
      {itemContainerClass}
      {itemBodySlotClass}
    >
      {#if item.bodyProps}
        <svelte:component
          this={item.body}
          {...item.bodyProps}
          on:checkBoxSelectionGroup={(e) => onCheckBoxSelectionGroup(e)}
        />
      {:else}
        <!-- TODO: Placeholder div; Replace with RichText component -->
        <div>{item.body}</div>
      {/if}
    </AccordionItem>
  {/each}
</div>
